var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppelCandidatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 10.5H13.4583V14.625C13.4583 14.9234 13.3463 15.2095 13.1471 15.4205C12.9478 15.6315 12.6775 15.75 12.3958 15.75C12.114 15.75 11.8437 15.6315 11.6445 15.4205C11.4452 15.2095 11.3333 14.9234 11.3333 14.625V10.5Z",
    stroke: "#B3B9C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2709 4.5H13.8126C14.0944 4.5 14.3646 4.61853 14.5639 4.8295C14.7631 5.04048 14.8751 5.32663 14.8751 5.625V9.375C14.8751 9.67337 14.7631 9.95952 14.5639 10.1705C14.3646 10.3815 14.0944 10.5 13.8126 10.5H9.91675",
    stroke: "#B3B9C4",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95833 5.25H4.25C3.68642 5.25 3.14591 5.48705 2.7474 5.90901C2.34888 6.33097 2.125 6.90326 2.125 7.5C2.125 8.09674 2.34888 8.66903 2.7474 9.09099C3.14591 9.51295 3.68642 9.75 4.25 9.75H4.95833",
    stroke: "#B3B9C4",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02838 12.375C5.00984 12.3748 4.99211 12.3669 4.979 12.353C4.96588 12.3392 4.95844 12.3204 4.95825 12.3007V2.32425C4.95825 2.283 4.98977 2.25 5.02838 2.25H6.19784C8.8385 2.25 10.9791 4.5165 10.9791 7.3125C10.9791 10.1085 8.8385 12.375 6.19784 12.375H5.02838Z",
    stroke: "#B3B9C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppelCandidatureIcon);
export default __webpack_public_path__ + "static/media/AppelCandidatureIcon.03d557bb4f970d187943ce367b100178.svg";
export { ForwardRef as ReactComponent };